var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('video-embed',{attrs:{"params":_vm.video.type === 'vimeo' && { title: 1 },"src":_vm.video.url,"css":"embed-responsive-21by9"}})}
var staticRenderFns = []

export { render, staticRenderFns }